import React from 'react';
import {Button} from '@xpertdox_js/xdcomponents';
import styles from './styles';
import { trackActivity } from '../../../../utils/activityTracker'
import { UserContext } from '../../../../Context/UserContext'
import { InstanceContext } from '../../../../InstanceContext'


const HeaderMenu = props => {

  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)
  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }
  const openSearch = () => {
    handleActivityLogUpdate(`HeaderMenu.openSearch`)
    props.openSearch()
  }

  let widths = [0, 0];
  let count = 0;
  if (props.searchable || props.tip) {
    count = props.searchable && props.tip ? 2 : 1;
    widths[0] += (count * 45) + 'px';
    widths[1] += (count * 40) + '%';
  }

  const showTip = () => props.controller.setTip(props.index);
  const clearTip = () => props.controller.clearTip();

   return(
    <div
      style={{
        ...styles.container,
        overflowY: 'hidden',
        width: widths[0],
        maxWidth: widths[1]
      }}
    >
      {/* Mini Menu */}
      <div style={{
        ...styles.innerMenu,
        // transform: `translateY(${props.searching ? '-100%' : '0%'})`,

      }}>
        {/* Tool Tip Button */}
        <Button
          styles={{
            ...styles.button,
            width: 100 / count + '%',
            display: 'inline-block'
          }}
          hoverStyles={styles.buttonHov}
          onMouseEnter={showTip}
          onMouseLeave={clearTip}
        >
          <svg style={{...styles.buttonSvg, width: '25px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256.7 160c37.5 0 63.3 20.8 63.3 50.7 0 19.8-9.6 33.5-28.1 44.4-17.4 10.1-23.3 17.5-23.3 30.3v7.9h-34.7l-.3-8.6c-1.7-20.6 5.5-33.4 23.6-44 16.9-10.1 24-16.5 24-28.9s-12-21.5-26.9-21.5c-15.1 0-26 9.8-26.8 24.6H192c.7-32.2 24.5-54.9 64.7-54.9zm-26.3 171.4c0-11.5 9.6-20.6 21.4-20.6 11.9 0 21.5 9 21.5 20.6s-9.6 20.6-21.5 20.6-21.4-9-21.4-20.6z"/></svg>
        </Button>
        {/* Search Button */}
        {props.searchable &&
          <Button
            onClick={openSearch}
            styles={styles.button}
            hoverStyles={styles.buttonHov}
            activeStyles={styles.buttonAct}
          >
            <svg style={styles.buttonSvg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M443.5 420.2L336.7 312.4c20.9-26.2 33.5-59.4 33.5-95.5 0-84.5-68.5-153-153.1-153S64 132.5 64 217s68.5 153 153.1 153c36.6 0 70.1-12.8 96.5-34.2l106.1 107.1c3.2 3.4 7.6 5.1 11.9 5.1 4.1 0 8.2-1.5 11.3-4.5 6.6-6.3 6.8-16.7.6-23.3zm-226.4-83.1c-32.1 0-62.3-12.5-85-35.2-22.7-22.7-35.2-52.9-35.2-84.9 0-32.1 12.5-62.3 35.2-84.9 22.7-22.7 52.9-35.2 85-35.2s62.3 12.5 85 35.2c22.7 22.7 35.2 52.9 35.2 84.9 0 32.1-12.5 62.3-35.2 84.9-22.7 22.7-52.9 35.2-85 35.2z"/></svg>
          </Button>
        }
      </div>
     </div>
   )
 }

 export default HeaderMenu;
